<template>
    <div>
        <template v-if="reports.length > 0">
            <div v-for="(group, indexGr) in reports" :key="indexGr" class="report">
                <div class="report-header">
                    <div class="report-header-left">
                        <h3>{{ group.name }}</h3>
                    </div>
                    <div class="report-header-right">
                        <a
                            :href="`https://reporting.${rsvDomain}/api/v1/report/zip?groups=${group.id}&jwt=${userJwt}`"
                            >{{ isMobile ? 'Скачать' : 'Скачать все отчеты' }}</a
                        >
                    </div>
                </div>
                <ReportingItem v-for="(item, index) in group.reports" :key="index" :item="item" />
            </div>
        </template>
        <div class="noreport" v-else>У тебя пока нет персональных отчетов</div>
    </div>
</template>

<script>
const getters = ['reports', 'isMobile'];
const actions = ['loadReports'];

import ReportingItem from '@/components/account/tabs/tab-more/components/ReportingItem.vue';
import { mapGetters, mapActions } from 'vuex';
import { getJwt } from '@/tools/http';

export default {
    name: 'Reporting',
    components: {
        ReportingItem,
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapGetters(getters),
        rsvDomain() {
            return window.rsvDomain || 'rsv.ru';
        },
        userJwt() {
            return getJwt();
        },
    },
    watch: {},
    async created() {
        this.loading = true;
        await this.loadReports();
        this.loading = false;
    },
    methods: {
        ...mapActions(actions),
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.box {
    background-color: #ffffff;
    border-radius: rem(10);
    padding: rem(32);
    display: block;

    @include on-mobile {
        padding: mrem(24) mrem(16);
        margin-top: mrem(16);
        background-color: white;
        box-shadow: 0 mrem(2) mrem(8) rgba(155, 161, 166, 0.23626);
        border-radius: mrem(10);
    }
}

.report {
    @include on-mobile {
        margin-bottom: mrem(24);
    }

    &-header {
        display: flex;

        &-left {
            flex: 1 1 auto;
            align-self: center;

            @include on-mobile {
            }

            h3 {
                font-weight: 600;
                font-size: rem(18);
                line-height: rem(28);
                display: block;

                @include on-mobile {
                    font-size: mrem(18);
                    line-height: mrem(21);
                }
            }
        }

        &-right {
            flex: 0 0 auto;
            font-size: rem(16);
            align-self: center;

            @include on-mobile {
                font-size: mrem(16);
            }

            a {
                color: #98a0a9;
            }
        }
    }
}
.noreport {
    width: 100% !important;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: rem(15);
    line-height: rem(22);
    font-weight: 600;
    color: #98a0a9;
}
</style>
